// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/careers-img/careersbg_hero.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Core Variables & Layout --- */
.careers-page-container {
    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;
    background: #fff;
    color: #0A0A0A;
    overflow-x: hidden;
    padding-bottom: 50px;
}

.careers-page-container * {
    box-sizing: border-box;
}

.careers-container {
    max-width: 1480px;
    margin: 0 auto;
    padding: 0 20px;
}

.careers-gold-text {
    color: #D3B06C;
}

.careers-solid-gold-text {
    color: #D3B06C;
}

.careers-gradient-text {
    background: linear-gradient(90deg, #D3B06C 0%, #E6C875 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* --- Hero Section --- */
.herosection_careers {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center / cover;
    width: 100%;
}

.careers-hero {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 80px 0;
    position: relative;
}

.careers-hero-content {
    flex: 1 1 500px;
    z-index: 1;
    padding-right: 40px;
}

.careers-hero-subtitle {
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    color: #D3B06C;
    background-color: #F0F9FF;
    padding: 6px 16px;
    border-radius: 20px;
    margin-bottom: 20px;
}

.careers-hero-title {
    font-size: 80px;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 25px;
    color: #15171E;
}

.careers-hero-desc {
    font-size: 20px;
    color: #6B7280;
    line-height: 1.8;
    margin-bottom: 35px;
    max-width: 100%;
    font-weight: 400;
}

.careers-btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #D1AA67;
    color: #fff;
    font-weight: 600;
    font-size: 18px;
    padding: 14px 26px;
    border-radius: 30px;
    text-decoration: none;
    transition: all 0.3s ease;
    border: none;
    cursor: pointer;
}

.careers-btn-primary:hover {
    background-color: #C09D5B;
    color: #fff;
    transform: translateY(-2px);
}

.careers-stats {
    display: flex;
    gap: 40px;
    margin-top: 40px;
}

.careers-stat-item h4 {
    font-size: 32px;
    font-weight: 700;
    color: #101828;
    margin: 10px 0px 5px;
}

.careers-stat-item p {
    font-size: 15px;
    font-weight: 500;
    color: #6A7282;
    margin: 0;

}

.careers-hero-image {
    flex: 1 1 500px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.careers-hero-image-wrapper {
    position: relative;
    width: 100%;
    max-width: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.main-bnr-img {
    max-width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
}

.floating-card {
    position: absolute;
    background: #fff;
    border-radius: 12px;
    padding: 12px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    z-index: 2;
}

.floating-card-growth {
    top: 30px;
    right: -20px;
}

.floating-card-team {
    bottom: 30px;
    left: -20px;
}

.fc-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fc-icon-green {
    background-color: #E6F8F0;
}

.fc-icon-blue {
    background-color: #E6F0FF;
}

.fc-text {
    display: flex;
    flex-direction: column;
}

.fc-title {
    font-size: 14px;
    font-weight: 800;
    color: #15171E;
    margin-bottom: 2px;
}

.fc-desc {
    font-size: 13px;
    color: #6B7280;
    font-weight: 500;
}

/* --- Why Build With AGCX Section --- */
.careers-why-build {
    padding: 80px 0 40px;
    text-align: center;
}

.careers-jobs-section h2 {
    margin-bottom: 18px;
}

.careers-section-title {
    font-size: 40px;
    font-weight: 700;
    color: #101828;
    margin-bottom: 50px;
}

.careers-features-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 30px;
    width: 100%;
    padding-top: 24px;
}

.careers-feature-card {
    flex: 1 1 180px;
    max-width: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.careers-feature-icon-wrapper {
    width: 84px;
    height: 84px;
    background-color: #FAEACE80;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.careers-feature-icon-wrapper img {
    width: 32px;
    height: 32px;
}

.careers-feature-title {
    font-size: 18px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 10px;
}

.careers-feature-desc {
    font-size: 16px;
    color: #6B7280;
    line-height: 1.5;
}

/* --- Find Your Next Opportunity Section --- */
.careers-jobs-section {
    padding: 60px 0;
    text-align: center;
}

.careers-jobs-subtitle {
    font-size: 16px;
    max-width: 550px;
    margin: 0 auto;
    color: #6B7280;
    margin-bottom: 40px;
}

.careers-jobs-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    max-width: 100%;
    margin: 0 auto 40px auto;
}

.careers-job-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #FCFCFC;
    border: 1px solid #F3F4F6;
    border-radius: 24px;
    padding: 30px;
    transition: all 0.3s ease;
    box-shadow: 0px 2px 10px #00000010;
}

.careers-job-row:hover {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
    border-color: #C9A84C;
}

.careers-job-info-left {
    display: flex;
    align-items: center;
    gap: 20px;
}

.careers-job-icon {
    width: 70px;
    height: 70px;
    background-color: #fff;
    border: 1px solid rgba(201, 168, 76, 0.103);
    box-shadow: 0px 2px 10px #00000010;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.careers-job-icon img {
    width: 24px;
    height: 24px;
}

.careers-job-details {
    text-align: left;
}

.careers-job-title {
    font-size: 21px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 5px;
}

.careers-job-meta {
    font-size: 17px;
    color: #6A7282;
    display: flex;
    align-items: center;
    gap: 15px;
}

.careers-job-meta span {
    display: flex;
    align-items: center;
    gap: 5px;
}

.careers-btn-outline {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    color: #D1AA67;
    font-weight: 500;
    font-size: 17px;
    padding: 10px 24px;
    border-radius: 12px;
    text-decoration: none;
    border: 1px solid #D1AA67;
    transition: all 0.3s ease;
}

.careers-btn-outline:hover {
    background-color: #C9A84C;
    color: #fff;
}

/* --- Our Hiring Process Section --- */
.careers-process-section {
    padding: 80px 0;
}

.careers-process-grid {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
}

.careers-process-card {
    flex: 1 1;
    max-width: 100%;
    background-color: #fff;
    border: 1px solid #F3F4F6;
    box-shadow: 0px 2px 10px #00000010;
    border-radius: 18px;
    padding: 30px;
    position: relative;
    text-align: left;
}

.careers-process-number {
    position: absolute;
    top: 18px;
    left: 30px;
    font-size: 15px;
    font-weight: 700;
    color: #D1AA6790;
}

.careers-social-section h2 {
    margin-bottom: 20px;
}

.careers-process-icon {
    width: 58px;
    height: 58px;
    background-color: #FCF4E7;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    margin-top: 20px;
}

.careers-process-icon img,
.careers-process-icon svg {
    width: 24px;
    height: 24px;
}

.careers-process-title {
    font-size: 18px;
    font-weight: 700;
    color: #1A1C23;
    margin-bottom: 10px;
}

.careers-process-desc {
    font-size: 14px;
    color: #6B7280;
    line-height: 1.5;
}

/* --- Social/Community Section --- */
.careers-social-section {
    padding: 80px 0 40px;
    text-align: center;
}

.careers-social-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    max-width: 1040px;
    margin: 50px auto 0;
}

.careers-social-card {
    flex: 1 1 190px;
    max-width: 190px;
    background-color: #fff;
    border: 1px solid #E5E7EB;
    border-radius: 16px;
    padding: 25px 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.3s ease;
}

.careers-social-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
}

.careers-social-card.highlighted {
    border: 1px solid #C9A84C;
    background-color: rgba(201, 168, 76, 0.03);
    box-shadow: 0 10px 25px rgba(201, 168, 76, 0.15);
    transform: scale(1.05);
    z-index: 2;
}

.careers-social-card.highlighted:hover {
    transform: scale(1.05) translateY(-5px);
}

.careers-social-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 15px;
}

.careers-social-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.careers-social-title {
    font-size: 15px;
    font-weight: 600;
    color: #1A1C23;
    margin-bottom: 8px;
}

.careers-social-desc {
    font-size: 12px;
    color: #6B7280;
    line-height: 1.4;
}


@media (max-width: 1500px) {

    .careers-container {
        max-width: 90%;
    }

    .careers-hero-title {
        font-size: 60px;
    }

}


@media (max-width: 1200px) {

    .careers-hero-content {
        flex: 1 1;
        padding-right: 0px;
    }

    .careers-hero-image {
        flex: 1 1;
    }

    .careers-hero-title {
        font-size: 42px;
    }

    .careers-hero-desc {
        font-size: 16px;
    }

    .careers-btn-primary {
        font-size: 15px;
        padding: 11px 24px;
    }

    .careers-stat-item h4 {
        font-size: 26px;
    }

    .careers-stat-item p {
        font-size: 13px;
    }

    .careers-section-title {
        font-size: 32px;
    }

    .careers-features-grid {
        gap: 18px;
    }

    .careers-feature-card {
        flex: 1 1;
        max-width: 100%;
    }

    .careers-feature-icon-wrapper {
        width: 70px;
        height: 70px;
    }

}


@media (max-width: 991px) {
    .careers-hero-title {
        font-size: 40px;
    }

    .careers-stats {
        flex-wrap: wrap;
        gap: 20px;
    }

    .careers-job-row {
        gap: 20px;
        text-align: center;
    }

    .careers-job-title {
        font-size: 18px;
    }

    .careers-job-meta {
        font-size: 15px;
    }

    .careers-btn-outline {
        font-size: 15px;
        padding: 8px 24px;
    }

    .careers-process-card {
        padding: 22px;
    }

    .careers-hero {
        padding: 50px 0;
    }

    .careers-hero-subtitle {
        font-size: 14px;
    }

    .careers-hero-title {
        font-size: 32px;
    }

    .careers-hero-desc {
        font-size: 15px;
    }

    .careers-hero-desc br {
        display: none;
    }

    .careers-why-build {
        padding: 40px 0 40px;
    }

    .careers-jobs-section {
        padding: 40px 0;
    }

    .careers-process-section {
        padding: 40px 0;
    }

    .careers-social-section {
        padding: 40px 0 30px;
    }

    .careers-section-title {
        font-size: 24px;
        margin-bottom: 24px;
    }

    .careers-social-card.highlighted {
        transform: scale(1);
    }

    .careers-social-card.highlighted:hover {
        transform: translateY(-5px);
    }
}


@media (max-width: 767px) {

    .careers-hero {
        flex-direction: column;
    }

    .careers-hero-title {
        font-size: 28px;
        margin-bottom: 15px;

    }

    .careers-hero-desc {
        font-size: 14px;
        margin-bottom: 15px;
    }

    .careers-btn-primary {
        font-size: 14px;
        padding: 10px 24px;
    }

    .careers-hero-content {
        text-align: center;
    }

    .careers-stats {
        gap: 20px;
        margin: 20px 0px 30px;
        justify-content: center;
    }

    .careers-stat-item h4 {
        font-size: 24px;
    }

    .careers-features-grid {
        gap: 24px;
        flex-direction: column;
    }

    .careers-job-row {
        text-align: start;
        align-items: start;
    }

    .careers-job-info-left {
        width: 100%;
    }

    .careers-process-grid {
        flex-direction: column;
    }

    .careers-process-section {
        padding: 20px 0;
    }

    .careers-social-section h2 br {
        display: none;
    }

    .careers-social-grid {
        margin: 30px auto 0;
    }

    .careers-btn-outline {
        font-size: 14px;
        padding: 8px 18px;
        white-space: nowrap;
    }

}



@media (max-width: 480px) {

    .careers-social-card {
        flex: 1 1;
        max-width: 50%;
    }

    .careers-job-row {
        flex-direction: column;
    }

    .careers-job-info-left {
        flex-direction: column;
    }

    .careers-job-row {
        align-items: center;
    }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Careers/Careers.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;IACI,oEAAoE;IACpE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4DAA4D;IAC5D,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA,yBAAyB;AACzB;IACI,mFAA2G;IAC3G,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;;AAEb;;AAEA;IACI,eAAe;IACf,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2CAA2C;IAC3C,UAAU;AACd;;AAEA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,wCAAwC;AACxC;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,+CAA+C;AAC/C;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2CAA2C;IAC3C,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA,uCAAuC;AACvC;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,SAAO;IACP,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,0CAA0C;IAC1C,gDAAgD;IAChD,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;;AAGA;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;AAGA;;IAEI;QACI,SAAO;QACP,kBAAkB;IACtB;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAO;QACP,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;AAEJ;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;;AAGA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,mBAAmB;;IAEvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,qBAAqB;QACrB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;AAEJ;;;;AAIA;;IAEI;QACI,SAAO;QACP,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;AAEJ","sourcesContent":["/* --- Core Variables & Layout --- */\n.careers-page-container {\n    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;\n    background: #fff;\n    color: #0A0A0A;\n    overflow-x: hidden;\n    padding-bottom: 50px;\n}\n\n.careers-page-container * {\n    box-sizing: border-box;\n}\n\n.careers-container {\n    max-width: 1480px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n.careers-gold-text {\n    color: #D3B06C;\n}\n\n.careers-solid-gold-text {\n    color: #D3B06C;\n}\n\n.careers-gradient-text {\n    background: linear-gradient(90deg, #D3B06C 0%, #E6C875 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n/* --- Hero Section --- */\n.herosection_careers {\n    background: url('../../../../public/images/careers-img/careersbg_hero.jpg') no-repeat center center / cover;\n    width: 100%;\n}\n\n.careers-hero {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    padding: 80px 0;\n    position: relative;\n}\n\n.careers-hero-content {\n    flex: 1 1 500px;\n    z-index: 1;\n    padding-right: 40px;\n}\n\n.careers-hero-subtitle {\n    display: inline-block;\n    font-size: 18px;\n    font-weight: 600;\n    color: #D3B06C;\n    background-color: #F0F9FF;\n    padding: 6px 16px;\n    border-radius: 20px;\n    margin-bottom: 20px;\n}\n\n.careers-hero-title {\n    font-size: 80px;\n    font-weight: 700;\n    line-height: 1.1;\n    margin-bottom: 25px;\n    color: #15171E;\n}\n\n.careers-hero-desc {\n    font-size: 20px;\n    color: #6B7280;\n    line-height: 1.8;\n    margin-bottom: 35px;\n    max-width: 100%;\n    font-weight: 400;\n}\n\n.careers-btn-primary {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #D1AA67;\n    color: #fff;\n    font-weight: 600;\n    font-size: 18px;\n    padding: 14px 26px;\n    border-radius: 30px;\n    text-decoration: none;\n    transition: all 0.3s ease;\n    border: none;\n    cursor: pointer;\n}\n\n.careers-btn-primary:hover {\n    background-color: #C09D5B;\n    color: #fff;\n    transform: translateY(-2px);\n}\n\n.careers-stats {\n    display: flex;\n    gap: 40px;\n    margin-top: 40px;\n}\n\n.careers-stat-item h4 {\n    font-size: 32px;\n    font-weight: 700;\n    color: #101828;\n    margin: 10px 0px 5px;\n}\n\n.careers-stat-item p {\n    font-size: 15px;\n    font-weight: 500;\n    color: #6A7282;\n    margin: 0;\n\n}\n\n.careers-hero-image {\n    flex: 1 1 500px;\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.careers-hero-image-wrapper {\n    position: relative;\n    width: 100%;\n    max-width: 500px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.main-bnr-img {\n    max-width: 100%;\n    height: auto;\n    position: relative;\n    z-index: 1;\n}\n\n.floating-card {\n    position: absolute;\n    background: #fff;\n    border-radius: 12px;\n    padding: 12px 20px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);\n    z-index: 2;\n}\n\n.floating-card-growth {\n    top: 30px;\n    right: -20px;\n}\n\n.floating-card-team {\n    bottom: 30px;\n    left: -20px;\n}\n\n.fc-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.fc-icon-green {\n    background-color: #E6F8F0;\n}\n\n.fc-icon-blue {\n    background-color: #E6F0FF;\n}\n\n.fc-text {\n    display: flex;\n    flex-direction: column;\n}\n\n.fc-title {\n    font-size: 14px;\n    font-weight: 800;\n    color: #15171E;\n    margin-bottom: 2px;\n}\n\n.fc-desc {\n    font-size: 13px;\n    color: #6B7280;\n    font-weight: 500;\n}\n\n/* --- Why Build With AGCX Section --- */\n.careers-why-build {\n    padding: 80px 0 40px;\n    text-align: center;\n}\n\n.careers-jobs-section h2 {\n    margin-bottom: 18px;\n}\n\n.careers-section-title {\n    font-size: 40px;\n    font-weight: 700;\n    color: #101828;\n    margin-bottom: 50px;\n}\n\n.careers-features-grid {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 30px;\n    width: 100%;\n    padding-top: 24px;\n}\n\n.careers-feature-card {\n    flex: 1 1 180px;\n    max-width: 220px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.careers-feature-icon-wrapper {\n    width: 84px;\n    height: 84px;\n    background-color: #FAEACE80;\n    border-radius: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.careers-feature-icon-wrapper img {\n    width: 32px;\n    height: 32px;\n}\n\n.careers-feature-title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #101828;\n    margin-bottom: 10px;\n}\n\n.careers-feature-desc {\n    font-size: 16px;\n    color: #6B7280;\n    line-height: 1.5;\n}\n\n/* --- Find Your Next Opportunity Section --- */\n.careers-jobs-section {\n    padding: 60px 0;\n    text-align: center;\n}\n\n.careers-jobs-subtitle {\n    font-size: 16px;\n    max-width: 550px;\n    margin: 0 auto;\n    color: #6B7280;\n    margin-bottom: 40px;\n}\n\n.careers-jobs-list {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    max-width: 100%;\n    margin: 0 auto 40px auto;\n}\n\n.careers-job-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #FCFCFC;\n    border: 1px solid #F3F4F6;\n    border-radius: 24px;\n    padding: 30px;\n    transition: all 0.3s ease;\n    box-shadow: 0px 2px 10px #00000010;\n}\n\n.careers-job-row:hover {\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n    border-color: #C9A84C;\n}\n\n.careers-job-info-left {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.careers-job-icon {\n    width: 70px;\n    height: 70px;\n    background-color: #fff;\n    border: 1px solid rgba(201, 168, 76, 0.103);\n    box-shadow: 0px 2px 10px #00000010;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.careers-job-icon img {\n    width: 24px;\n    height: 24px;\n}\n\n.careers-job-details {\n    text-align: left;\n}\n\n.careers-job-title {\n    font-size: 21px;\n    font-weight: 600;\n    color: #101828;\n    margin-bottom: 5px;\n}\n\n.careers-job-meta {\n    font-size: 17px;\n    color: #6A7282;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.careers-job-meta span {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.careers-btn-outline {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n    color: #D1AA67;\n    font-weight: 500;\n    font-size: 17px;\n    padding: 10px 24px;\n    border-radius: 12px;\n    text-decoration: none;\n    border: 1px solid #D1AA67;\n    transition: all 0.3s ease;\n}\n\n.careers-btn-outline:hover {\n    background-color: #C9A84C;\n    color: #fff;\n}\n\n/* --- Our Hiring Process Section --- */\n.careers-process-section {\n    padding: 80px 0;\n}\n\n.careers-process-grid {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 20px;\n}\n\n.careers-process-card {\n    flex: 1;\n    max-width: 100%;\n    background-color: #fff;\n    border: 1px solid #F3F4F6;\n    box-shadow: 0px 2px 10px #00000010;\n    border-radius: 18px;\n    padding: 30px;\n    position: relative;\n    text-align: left;\n}\n\n.careers-process-number {\n    position: absolute;\n    top: 18px;\n    left: 30px;\n    font-size: 15px;\n    font-weight: 700;\n    color: #D1AA6790;\n}\n\n.careers-social-section h2 {\n    margin-bottom: 20px;\n}\n\n.careers-process-icon {\n    width: 58px;\n    height: 58px;\n    background-color: #FCF4E7;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n    margin-top: 20px;\n}\n\n.careers-process-icon img,\n.careers-process-icon svg {\n    width: 24px;\n    height: 24px;\n}\n\n.careers-process-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #1A1C23;\n    margin-bottom: 10px;\n}\n\n.careers-process-desc {\n    font-size: 14px;\n    color: #6B7280;\n    line-height: 1.5;\n}\n\n/* --- Social/Community Section --- */\n.careers-social-section {\n    padding: 80px 0 40px;\n    text-align: center;\n}\n\n.careers-social-grid {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 20px;\n    max-width: 1040px;\n    margin: 50px auto 0;\n}\n\n.careers-social-card {\n    flex: 1 1 190px;\n    max-width: 190px;\n    background-color: #fff;\n    border: 1px solid #E5E7EB;\n    border-radius: 16px;\n    padding: 25px 15px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    transition: all 0.3s ease;\n}\n\n.careers-social-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n}\n\n.careers-social-card.highlighted {\n    border: 1px solid #C9A84C;\n    background-color: rgba(201, 168, 76, 0.03);\n    box-shadow: 0 10px 25px rgba(201, 168, 76, 0.15);\n    transform: scale(1.05);\n    z-index: 2;\n}\n\n.careers-social-card.highlighted:hover {\n    transform: scale(1.05) translateY(-5px);\n}\n\n.careers-social-icon {\n    width: 48px;\n    height: 48px;\n    margin-bottom: 15px;\n}\n\n.careers-social-icon img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.careers-social-title {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1A1C23;\n    margin-bottom: 8px;\n}\n\n.careers-social-desc {\n    font-size: 12px;\n    color: #6B7280;\n    line-height: 1.4;\n}\n\n\n@media (max-width: 1500px) {\n\n    .careers-container {\n        max-width: 90%;\n    }\n\n    .careers-hero-title {\n        font-size: 60px;\n    }\n\n}\n\n\n@media (max-width: 1200px) {\n\n    .careers-hero-content {\n        flex: 1;\n        padding-right: 0px;\n    }\n\n    .careers-hero-image {\n        flex: 1;\n    }\n\n    .careers-hero-title {\n        font-size: 42px;\n    }\n\n    .careers-hero-desc {\n        font-size: 16px;\n    }\n\n    .careers-btn-primary {\n        font-size: 15px;\n        padding: 11px 24px;\n    }\n\n    .careers-stat-item h4 {\n        font-size: 26px;\n    }\n\n    .careers-stat-item p {\n        font-size: 13px;\n    }\n\n    .careers-section-title {\n        font-size: 32px;\n    }\n\n    .careers-features-grid {\n        gap: 18px;\n    }\n\n    .careers-feature-card {\n        flex: 1;\n        max-width: 100%;\n    }\n\n    .careers-feature-icon-wrapper {\n        width: 70px;\n        height: 70px;\n    }\n\n}\n\n\n@media (max-width: 991px) {\n    .careers-hero-title {\n        font-size: 40px;\n    }\n\n    .careers-stats {\n        flex-wrap: wrap;\n        gap: 20px;\n    }\n\n    .careers-job-row {\n        gap: 20px;\n        text-align: center;\n    }\n\n    .careers-job-title {\n        font-size: 18px;\n    }\n\n    .careers-job-meta {\n        font-size: 15px;\n    }\n\n    .careers-btn-outline {\n        font-size: 15px;\n        padding: 8px 24px;\n    }\n\n    .careers-process-card {\n        padding: 22px;\n    }\n\n    .careers-hero {\n        padding: 50px 0;\n    }\n\n    .careers-hero-subtitle {\n        font-size: 14px;\n    }\n\n    .careers-hero-title {\n        font-size: 32px;\n    }\n\n    .careers-hero-desc {\n        font-size: 15px;\n    }\n\n    .careers-hero-desc br {\n        display: none;\n    }\n\n    .careers-why-build {\n        padding: 40px 0 40px;\n    }\n\n    .careers-jobs-section {\n        padding: 40px 0;\n    }\n\n    .careers-process-section {\n        padding: 40px 0;\n    }\n\n    .careers-social-section {\n        padding: 40px 0 30px;\n    }\n\n    .careers-section-title {\n        font-size: 24px;\n        margin-bottom: 24px;\n    }\n\n    .careers-social-card.highlighted {\n        transform: scale(1);\n    }\n\n    .careers-social-card.highlighted:hover {\n        transform: translateY(-5px);\n    }\n}\n\n\n@media (max-width: 767px) {\n\n    .careers-hero {\n        flex-direction: column;\n    }\n\n    .careers-hero-title {\n        font-size: 28px;\n        margin-bottom: 15px;\n\n    }\n\n    .careers-hero-desc {\n        font-size: 14px;\n        margin-bottom: 15px;\n    }\n\n    .careers-btn-primary {\n        font-size: 14px;\n        padding: 10px 24px;\n    }\n\n    .careers-hero-content {\n        text-align: center;\n    }\n\n    .careers-stats {\n        gap: 20px;\n        margin: 20px 0px 30px;\n        justify-content: center;\n    }\n\n    .careers-stat-item h4 {\n        font-size: 24px;\n    }\n\n    .careers-features-grid {\n        gap: 24px;\n        flex-direction: column;\n    }\n\n    .careers-job-row {\n        text-align: start;\n        align-items: start;\n    }\n\n    .careers-job-info-left {\n        width: 100%;\n    }\n\n    .careers-process-grid {\n        flex-direction: column;\n    }\n\n    .careers-process-section {\n        padding: 20px 0;\n    }\n\n    .careers-social-section h2 br {\n        display: none;\n    }\n\n    .careers-social-grid {\n        margin: 30px auto 0;\n    }\n\n    .careers-btn-outline {\n        font-size: 14px;\n        padding: 8px 18px;\n        white-space: nowrap;\n    }\n\n}\n\n\n\n@media (max-width: 480px) {\n\n    .careers-social-card {\n        flex: 1;\n        max-width: 50%;\n    }\n\n    .careers-job-row {\n        flex-direction: column;\n    }\n\n    .careers-job-info-left {\n        flex-direction: column;\n    }\n\n    .careers-job-row {\n        align-items: center;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
